/**
 * useFormatters
 * Funções de formatação reutilizáveis em qualquer componente.
 */
export function useFormatters() {
  function formatarEuro(valor) {
    if (valor == null) return "–";
    return new Intl.NumberFormat("fr-FR", {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(valor);
  }

  function formatarData(data) {
    if (!data) return "–";
    return new Date(data).toLocaleDateString("pt-PT", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  }

  function formatDesconto(v) {
    if (v === null || v === undefined || v === "") return "—";
    const n = Number(v);
    return Number.isFinite(n) ? `${n.toString().replace(".", ",")}%` : String(v);
  }

  function calcularIdade(dataNascimento) {
    if (!dataNascimento) return null;
    const hoje = new Date();
    const nasc = new Date(dataNascimento);
    let idade = hoje.getFullYear() - nasc.getFullYear();
    const m = hoje.getMonth() - nasc.getMonth();
    if (m < 0 || (m === 0 && hoje.getDate() < nasc.getDate())) idade--;
    return idade;
  }

  function faixaEtaria(idade) {
    if (idade == null) return "–";
    if (idade < 18) return "<18";
    if (idade <= 24) return "18–24";
    if (idade <= 34) return "25–34";
    if (idade <= 44) return "35–44";
    if (idade <= 54) return "45–54";
    return "55+";
  }

  function slugify(str) {
    return str
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .replace(/\s+/g, "_")
      .replace(/[^a-z0-9_]/g, "");
  }

  return { formatarEuro, formatarData, formatDesconto, calcularIdade, faixaEtaria, slugify };
}
